export const KEY_MY_APPS_SORT = 'KEY_MY_APPS_SORT'

export const KEY_SSO_APPS_SORT = 'KEY_SSO_APPS_SORT'

export const KEY_SHOW_EHR_DIALOG = 'KEY_SHOW_EHR_DIALOG'
